var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersThreeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C14.0711 16.875 15.75 15.1961 15.75 13.125C15.75 11.0539 14.0711 9.375 12 9.375C9.92893 9.375 8.25 11.0539 8.25 13.125C8.25 15.1961 9.92893 16.875 12 16.875Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.875C19.2484 10.8743 20.1098 11.0772 20.891 11.4677C21.6722 11.8583 22.3516 12.4256 22.8751 13.1246",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12474 13.1248C1.64828 12.4257 2.32765 11.8584 3.10886 11.4678C3.89007 11.0772 4.75161 10.8743 5.62501 10.875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60321 20.2499C7.09588 19.238 7.86314 18.385 8.8174 17.7882C9.77167 17.1914 10.8745 16.875 12 16.875C13.1255 16.875 14.2283 17.1914 15.1826 17.7882C16.1368 18.3849 16.9041 19.238 17.3968 20.2499",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62501 10.875C5.05579 10.8749 4.49835 10.7129 4.01779 10.4078C3.53722 10.1027 3.15336 9.66726 2.91102 9.1522C2.66869 8.63715 2.57788 8.06378 2.64922 7.49906C2.72055 6.93433 2.95107 6.40155 3.31386 5.96293C3.67665 5.52431 4.15674 5.19796 4.69807 5.02198C5.2394 4.84599 5.81962 4.82765 6.37098 4.96908C6.92235 5.11052 7.42209 5.40589 7.81187 5.82072C8.20165 6.23554 8.46536 6.7527 8.57222 7.31179",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4278 7.31186C15.5346 6.75268 15.7983 6.23543 16.1881 5.82051C16.5779 5.40559 17.0777 5.11014 17.6291 4.96865C18.1805 4.82716 18.7608 4.84548 19.3022 5.02147C19.8436 5.19745 20.3238 5.52384 20.6866 5.96251C21.0495 6.40119 21.28 6.93404 21.3514 7.49885C21.4227 8.06365 21.3319 8.63709 21.0895 9.1522C20.8471 9.66731 20.4631 10.1028 19.9825 10.4079C19.5018 10.713 18.9443 10.875 18.375 10.875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersThreeIcon);
export default __webpack_public_path__ + "static/media/users-three-icon.94b85c926c44fcc2cfcde96cae7503b46fc5158d9f460c4aa02ae5a32efbbd8b.svg";
export { ForwardRef as ReactComponent };